module.exports = __webpack_public_path__ + "media/assets/landing_page_island_green-3cda8554.svg";